/* eslint-disable react/no-unescaped-entities */
import React from 'react'
import PropTypes from 'prop-types'
import { Image, Button } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars } from '@fortawesome/free-solid-svg-icons'
import { mobilePhone, wavenet_logo } from '../asset'
import CIIcon from './CIIcon'

function FullScreenPreview({ srcs, isMediaVisible, setFullScreenShowMedia }) {
  const validImages = Array.isArray(srcs) ? srcs.filter((src) => src.file) : []

  return (
    <div
      className="scroller-hide"
      style={{ maxHeight: '57.5vh', overflow: 'auto' }}
    >
      <div className="w-100 pb-1">
        <Image
          className="position-absolute"
          src={mobilePhone}
          style={{ width: '19.5rem', right: '16%', top: '2%' }}
        />
      </div>
      <div style={{ position: 'relative' }}>
        <div
          className="border-bottom mb-3 d-flex"
          style={{ width: '240px', height: '55px', zIndex: '0' }}
        >
          <div className="w-80 m-auto ms-auto">
            <Image src={wavenet_logo} className="w-75 ps-3" />
          </div>
          <div className="w-20 m-auto ms-auto d-flex">
            <FontAwesomeIcon icon={faBars} className="text-end" />
          </div>
        </div>
        <div className="text-title" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-ban1" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line2" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <br />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
      </div>

      {validImages.map((src) => {
        let imageSrc
        if (src.file instanceof File) {
          imageSrc = URL.createObjectURL(src.file)
        } else if (
          typeof src.file === 'string' &&
          src.file.startsWith('blob:')
        ) {
          imageSrc = src.file
        } else {
          imageSrc = `/api/file/${src.file}`
        }

        const imageKey = `image-${src.file.name}-${src.file.lastModified}`

        return (
          isMediaVisible && (
            <>
              <img
                key={imageKey}
                className="d-flex"
                src={imageSrc}
                alt={src.label}
                style={{
                  objectFit: 'cover',
                  height: 'auto',
                  maxHeight: '470px',
                  overflow: 'hidden',
                  position: 'absolute',
                  bottom: '12%',
                  width: '240px',
                  zIndex: '1500',
                  alignItems: 'flex-end',
                }}
              />
              <Button
                key={`btn-${imageKey}`}
                onClick={() => setFullScreenShowMedia(false)}
                className="position-absolute"
                style={{
                  bottom: '82%',
                  right: '19.5%',
                  width: '25px',
                  background: 'rgba(0, 0, 0, 0.5)',
                  border: 'none',
                  padding: '0',
                  borderRadius: '50%',
                  zIndex: '2001',
                }}
              >
                ✕
              </Button>
            </>
          )
        )
      })}

      <div style={{ position: 'relative', paddingTop: '1rem' }}>
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <br />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
      </div>
      <CIIcon bottom="12%" right="19.25%" />
    </div>
  )
}

FullScreenPreview.propTypes = {
  srcs: PropTypes.arrayOf(
    PropTypes.shape({
      file: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(File),
        PropTypes.instanceOf(Blob),
      ]),
      label: PropTypes.string,
    })
  ),
  isMediaVisible: PropTypes.bool.isRequired,
  setFullScreenShowMedia: PropTypes.func.isRequired,
}

FullScreenPreview.defaultProps = {
  srcs: [],
}

export default FullScreenPreview
